module.exports = __webpack_public_path__ + "fonts/OpenSans300italic.97534dd4.woff";